import type { en } from "./en";

// Turkish translations. Missing keys fall back to English via i18next.
export const tr: typeof en = {
  common: {
    home: "Ana sayfa",
    no_scores: "Henüz puan yok",
    points_count_one: "{{count}} puan",
    points_count_other: "{{count}} puan",
    questions_count_one: "{{count}} soru",
    questions_count_other: "{{count}} soru",
  },
  home: {
    placeholder: "Oyun kodu",
    enter: "Gir",
    error_invalid_code: "Öğretmeninden aldığın 6 karakterli oyun kodunu gir.",
    footer: "Binogi.com ürünlerinden Binogi Buzz oturumu başlat.",
    language_label: "Dil",
  },
  errors: {
    generic: "Bir şeyler ters gitti. Lütfen tekrar dene.",
    stale_client: "Sayfan güncel değil — lütfen yenile.",
    session_not_found: "Bu oturum bulunamadı.",
    session_not_open: "Bu oturum sona erdi.",
    session_not_active: "Bu soru ya da oturum zaten sona erdi.",
    not_teacher: "Bunu yalnızca öğretmen yapabilir.",
    already_answered: "Bu soruyu zaten cevapladın.",
    wrong_question_index: "Bu soru henüz başlamadı.",
    name_taken: "Bu ad zaten alınmış. Başka bir ad dene.",
    character_busy: "Şu anda sana bir karakter verilemedi — lütfen tekrar dene.",
  },
  host: {
    input: {
      heading: "Buzz başlat",
      lead:
        "Öğrencilerinin çalıştığı Binogi ders kodunu gir. Sorularını yükleyip tahtaya yansıtabileceğin bir oturum oluşturalım.",
      lesson_code_label: "Ders kodu",
      placeholder_code: "BIH750",
      load_button: "Dersi yükle",
      try_hint: "Dene:",
      error_invalid_code: "Bir Binogi ders kodu gir, örn. BIH750.",
      error_not_found: "{{code}} koduyla ders bulunamadı.",
      error_unreachable: "Ders sunucusuna ulaşılamadı. Bağlantını kontrol edip tekrar dene.",
      error_no_questions: "{{code}} dersinde Buzz’ın kullanabileceği soru yok.",
      error_no_level_questions: "{{code}} dersinde seçilen seviyede soru yok.",
    },
    loading: "Ders yükleniyor…",
    placeholder_title: "Binogi Buzz oturumu başlat",
    tab_details: "Detaylar",
    tab_questions: "Sorular",
    settings: "Ayarlar",
    number_of_students: "Öğrenci sayısı",
    fewer_students: "Daha az öğrenci",
    more_students: "Daha çok öğrenci",
    player_names: "Oyuncu isimleri",
    player_anonymous: "Anonim",
    player_self_chosen: "Öğrenciler seçer",
    language: "Dil",
    language_teacher: "Öğretmen seçer",
    language_students: "Öğrenciler seçer",
    time_per_question: "Soru başına süre",
    time_option: "{{seconds}} sn",
    start_button: "Oturumu başlat",
    start_disabled: "Başlamak için sınıf büyüklüğünü belirle",
    creating: "Oturum oluşturuluyor…",
    error_no_questions: "Başlamadan önce en az bir soru bırak.",
    error_create_failed: "Oturum oluşturulamadı",
    error_load_failed: "Ders yüklenemedi",
    no_session: "Devam eden oturum yok.",
    back_to_review: "Sorulara dön",
    errors: {
      dismiss: "Kapat",
      refresh: "Yenile",
      attach_failed: "Bu ekran öğretmen olarak bağlanamadı.",
      unreachable: "Sunucuya ulaşılamadı. Tekrar denemek için sayfayı yenile.",
      no_token: "Bu sekme artık testi yönetemez. Yeni bir oturum başlatmak için Buzz’ı dersinden aç.",
      taken_over: "Bu test artık başka bir ekrandan yönetiliyor.",
      stale_question: "Buzz bu test sırasında güncellendi, bu yüzden bu ekran teste devam edemez. Testi sınıfın kaldığı yerden sürdürmek için sayfayı yeniden yükle.",
      question_moved_on: "Test zaten ilerledi, bu yüzden bu ekran geride kaldı. Testi sınıfın kaldığı yerden sürdürmek için sayfayı yeniden yükle.",
    },
    entry: {
      opening: "Öğretmen görünümü açılıyor…",
      token_title: "Bu öğretmen bağlantısı açılamıyor",
      token_body: "Bağlantıda öğretmen anahtarı eksik ya da süresi dolmuş. Yeni bir oturum oluşturmak için Buzz’ı dersinden aç.",
      not_found_title: "Oturum bulunamadı",
      not_found_body: "Bu test oturumu artık yok. Devam etmek için yeni bir oturum oluştur.",
      back: "Başa dön",
    },
    questions: {
      drag_aria: "Sıralamak için sürükle",
      remove_aria: "Soruyu kaldır",
      empty: "Bu oturumda hiç soru kalmadı.",
      add: "Ekle",
      add_aria: "Soru ekle: {{text}}",
      add_all: "Hepsini ekle",
      add_all_n: "{{count}} sorunun tümünü ekle",
      more_one: "Bu derste {{count}} soru daha var",
      more_other: "Bu derste {{count}} soru daha var",
      level_easy: "Kolay",
      level_medium: "Orta",
      level_hard: "Zor",
      multi: "Çoklu",
    },
    lobby: {
      go_to: "<strong>buzz.binogi.com</strong> adresine git ve şunu gir:",
      or_qr: "…ya da QR kodu tara",
      students_joined_of: "{{expected}} öğrenciden {{joined}} tanesi katıldı",
      students_joined_one: "{{count}} öğrenci katıldı",
      students_joined_other: "{{count}} öğrenci katıldı",
      waiting: "Öğrencilerin katılması bekleniyor…",
      start_game: "Oyunu başlat",
      connected: "Bağlandı",
      connecting: "Bağlanıyor…",
      copy_link: "Bağlantıyı kopyala",
      copy_link_copied: "Kopyalandı!",
    },
    question: {
      header: "{{total}} sorudan {{index}}.",
      level: "Seviye {{level}}",
      none: "Etkin soru yok.",
      answered: "Cevaplandı",
      top_n: "İlk {{count}}",
      answers_heading: "Cevaplar",
      end_question: "Soruyu bitir",
      next_question: "Sonraki soru",
      see_results: "Son sonuçları gör",
    },
    results: {
      heading: "Son sonuçlar",
      all_players: "Tüm oyuncular",
      end_session: "Oturumu bitir",
      new_session: "Yeni oturum",
      none: "Bu oturumda hiç oyuncu yok.",
    },
  },
  join: {
    code_label: "Oyun kodu",
    name_label: "Adın",
    name_placeholder: "Adını yaz",
    join_button: "Katıl",
    joining: "Katılıyor…",
    checking: "Kontrol ediliyor…",
    character_hint: "Katıldığında eğlenceli bir Binogi karakter adı alacaksın.",
    error_not_found:
      "Bu kod henüz canlı bir oturuma ait değil. Öğretmeninle kontrol et.",
    error_lookup_failed: "Oturum aranamadı",
    error_code_required: "6 karakterli kodu gir.",
    error_name_required: "Adını gir.",
  },
  play: {
    superseded: "Başka bir sekmede bağlısın — burada oynamaya devam etmek için onu kapat.",
    back_to_join: "Katılma ekranına dön",
    no_round: "Tur verisi yok.",
    not_joined: "Henüz bir oturuma katılmadın.",
    no_question: "Etkin soru yok.",
    keep_awake_hint: "Ekranın açık kalması için ekrana dokun",
    waiting: {
      you_are: "Sen",
      get_ready_named: "Hazır ol, {{name}}!",
      get_ready: "Quiz için hazır ol!",
      in_room_label: "Odadaki öğrenciler",
      in_room_one: "Odada {{count}} öğrenci var",
      in_room_other: "Odada {{count}} öğrenci var",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "Cevaplandı!",
      times_up: "Süre doldu",
      submit: "Gönder",
      submit_n: "{{count}} cevabı gönder",
    },
    between: {
      correct: "Doğru!",
      wrong: "Az kaldı!",
      times_up: "Süre doldu",
      points_gained: "+{{count}} puan",
      your_score: "Skorun",
      your_rank: "{{rank}}. sıradasın",
      top_n: "İlk {{count}}",
      waiting_next: "Sonraki soru bekleniyor…",
    },
    finished: {
      heading: "Binogi Buzz oynadığın için teşekkürler!",
      your_final_rank: "Son sıralaman",
      top_n: "İlk {{count}}",
      none: "Gösterilecek sonuç yok.",
    },
  },
  characters: {
    heading: "Binogi karakterleri",
    lead: "{{count}} öğrenci katıldığında bu sırayla bir karakter alır.",
  },
};
